export default "__VITE_ASSET__2a518b27__"